<template>
  <div id="pin-form">
    <form
      id="new_pin"
      ref="form"
      name="lastpass-disable-search"
      class="new_pin"
      accept-charset="UTF-8"
      :action="formAction"
      enctype="multipart/form-data"
      :method="pin.id ? 'put' : 'post'"
      @submit.prevent="submitForm"
    >
      <input name="utf8" type="hidden" value="✓">
      <input type="hidden" name="authenticity_token" :value="csrfToken">

      <img :src="pin.photo.remote_url || pin.photo.url" class="pin_photo" height="150" width="300" alt="">

      <div id="pin-text-data">
        <input id="pin_name" v-model="pin.name" placeholder="Nom" type="text" name="pin[name]">

        <table id="pin_fields">
          <tr id="lat_field" class="field">
            <td class="field_name">Latitude</td>
            <td class="field_value"><input id="pin_lat" v-model.number="pin.position.lat" type="text" name="pin[lat]"></td>
          </tr>
          <tr id="lon_field" class="Longitude">
            <td class="field_name">Longitude</td>
            <td class="field_value"><input id="pin_lon" v-model.number="pin.position.lng" type="text" name="pin[lon]"></td>
          </tr>
          <tr id="city_field" class="field">
            <td class="field_name">Ville</td>
            <td class="field_value"><input id="pin_city" v-model="pin.city" type="text" name="pin[city]"></td>
          </tr>
          <tr id="region_field" class="field">
            <td class="field_name">Region</td>
            <td class="field_value"><input id="pin_region" v-model="pin.region" type="text" name="pin[region]"></td>
          </tr>
          <tr id="country_field" class="field">
            <td class="field_name">Pays</td>
            <td class="field_value"><input id="pin_country" v-model="pin.country" type="text" name="pin[country]"></td>
          </tr>
          <tr id="visited_field" class="field">
            <td class="field_name">Visite ?</td>
            <td class="field_value">
              <input name="pin[visited]" type="hidden" value="false">
              <input id="pin_visited" v-model="pin.visited" type="checkbox" name="pin[visited]" value="true">
            </td>
          </tr>
          <tr v-if="pin.visited" id="to_visit_again_field" class="field">
            <td class="field_name">Je veux y retourner ?</td>
            <td class="field_value">
              <input name="pin[to_visit_again]" type="hidden" value="false">
              <input id="pin_to_visit_again" v-model="pin.to_visit_again" type="checkbox" name="pin[to_visit_again]" value="true">
            </td>
          </tr>
          <tr id="pin_type_field" class="field">
            <td class="field_name">Type</td>
            <td class="field_value">
              <select v-model="pin.pin_type" name="pin[pin_type]">
                <option value="default">Normal</option>
                <option value="accommodation">Hebergement</option>
                <option value="restaurant">Restaurant</option>
              </select>
            </td>
          </tr>
        </table>
        <input v-if="!pin.visited" name="pin[to_visit_again]" type="hidden" value="false">

        <h3>Photo</h3>
        <div class="form_group">
          <label for="pin_photo">Url</label>
          <input id="pin_photo" type="file" name="pin[photo]">
          <input id="pin_remote_photo_url" v-model="pin.photo.remote_url" type="text" name="pin[remote_photo_url]">
        </div>

        <h3>Commentaires</h3>
        <textarea id="pin_comments" v-model="pin.comments" name="pin[comments]"></textarea>
      </div>

      <div id="pin-action-buttons" :class="{ loading: isSubmitting }">
        <input id="submit" type="submit" name="commit" value="Envoyer" class="box button main-button" :disabled="isSubmitting">
        <img :src="loadingUrl" class="loading_icon" height="50" width="50" alt="">
      </div>
    </form>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'

const props = defineProps({
  pin: {
    type: Object,
    required: true,
  },
  pinsUrl: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['pin-created', 'pin-updated', 'pin-selected', 'pin-center'])
const form = ref(null)
const isSubmitting = ref(false)
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ''
const loadingUrl = window.CollectionneurAssets.loading

const formAction = computed(() => `${props.pinsUrl}${props.pin.id ? `/${props.pin.id}` : ''}.json`)

async function submitForm() {
  isSubmitting.value = true
  try {
    const response = await fetch(formAction.value, {
      method: props.pin.id ? 'PUT' : 'POST',
      body: new FormData(form.value),
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': csrfToken,
      },
    })

    const data = await response.json()
    if (!response.ok) {
      console.log(data)
      return
    }

    emit(props.pin.id ? 'pin-updated' : 'pin-created', data)
    emit('pin-selected', data)
  } catch (error) {
    console.log(error)
  } finally {
    isSubmitting.value = false
  }
}

onMounted(() => emit('pin-center', props.pin))
</script>
